
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBusiness = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 46,
  height: 28,
  viewBox: "0 0 32 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#business_79db3fbdf26d5e41__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 .625c2.016 0 3.686.429 4.833 1.686.856.937 1.262 2.173 1.465 3.539h6.535l.263.013a2.567 2.567 0 0 1 2.303 2.553V25.1l-.012.262a2.568 2.568 0 0 1-2.291 2.291l-.263.013H3.166a2.567 2.567 0 0 1-2.553-2.304L.6 25.1V8.416A2.567 2.567 0 0 1 3.166 5.85h6.536c.203-1.366.608-2.602 1.464-3.54C12.314 1.055 13.983.626 16 .626Zm6.508 24.291h6.141V8.6h-6.141v16.316Zm-10.266 0h7.516V8.6h-7.516v16.316Zm-8.892 0h6.142V8.6H3.35v16.316ZM16 3.375c-1.69 0-2.417.366-2.804.79-.288.316-.52.805-.684 1.594h6.975c-.164-.789-.396-1.278-.684-1.594-.387-.424-1.113-.79-2.803-.79Z",
  fill: "url(#business_79db3fbdf26d5e41__b)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "business_79db3fbdf26d5e41__b",
  x1: 0.6,
  y1: 0.625,
  x2: 31.174,
  y2: 0.373,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.16
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "business_79db3fbdf26d5e41__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v28H0z"
})))));

      const __svgRaw = "<svg width=\"46\" height=\"28\" viewBox=\"0 0 32 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<g clip-path=\"url(#clip0_5099_655)\">\r\n<path d=\"M16 0.625C18.0163 0.625068 19.6855 1.05382 20.833 2.31055C21.6891 3.24831 22.0951 4.48412 22.2979 5.84961H28.833L29.0957 5.86328C30.3896 5.99487 31.3991 7.08749 31.3994 8.41602V25.0996L31.3867 25.3623C31.264 26.5701 30.3035 27.5305 29.0957 27.6533L28.833 27.666H3.16602C1.83741 27.6658 0.744846 26.6562 0.613281 25.3623L0.599609 25.0996V8.41602C0.599949 6.99894 1.74893 5.84988 3.16602 5.84961H9.70215C9.90486 4.4842 10.31 3.24828 11.166 2.31055C12.3136 1.05368 13.9835 0.625035 16 0.625ZM22.5078 24.916H28.6494V8.59961H22.5078V24.916ZM12.2422 24.916H19.7578V8.59961H12.2422V24.916ZM3.34961 24.916H9.49219V8.59961H3.34961V24.916ZM16 3.375C14.3091 3.37504 13.583 3.74141 13.1963 4.16504C12.9081 4.4809 12.6757 4.97009 12.5117 5.75879H19.4873C19.3233 4.97001 19.091 4.48089 18.8027 4.16504C18.416 3.74148 17.6905 3.37507 16 3.375Z\" fill=\"url(#paint0_linear_5099_655)\"/>\r\n</g>\r\n<defs>\r\n<linearGradient id=\"paint0_linear_5099_655\" x1=\"0.599609\" y1=\"0.625\" x2=\"31.1742\" y2=\"0.372751\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.159758\" stop-color=\"black\"/>\r\n<stop offset=\"1\" stop-color=\"black\"/>\r\n</linearGradient>\r\n<clipPath id=\"clip0_5099_655\">\r\n<rect width=\"32\" height=\"28\" fill=\"white\"/>\r\n</clipPath>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/business.79db3fbdf26d5e41da0f576661d53522.svg"),
        {
          React: SvgBusiness,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      